import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { HeaderComponent } from './../header/header.component';
import { FooterComponent } from './../footer/footer.component'; 
import { ProfileComponent } from './../profile/profile.component';
import { HistoryComponent } from './../history/history.component';
import { BannerComponent } from './../banner/banner.component';
import { SharedModule } from '../../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReviewOrderComponent } from '../review-order/review-order.component';
import { PaymentConfirmComponent } from '../../components/payment-confirm/payment-confirm.component'
import { LoginComponent } from './../login/login.component'
import { TwoFactorVerificationComponent } from '../two-factor-verification/two-factor-verification.component';
import { ErrorMessagesComponent } from '../error-messages/error-messages.component';
import { SubscriptionComponent } from '../subscription/subscription.component';
import { CallbackComponent } from '../callback/callback.component';
import { NgbDatepickerModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileEditComponent} from './../profile-edit/profile-edit.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { SignatureCaptureComponent } from '../signature-capture/signature-capture.component';
import { ProcessPaymentComponent } from '../process-payment/process-payment.component';

@NgModule({
  declarations: [
    DashboardComponent,
    ProfileComponent,
    HistoryComponent,
    BannerComponent,
    ReviewOrderComponent,
    PaymentConfirmComponent,
    LoginComponent,
    TwoFactorVerificationComponent,
    ErrorMessagesComponent,
    SubscriptionComponent,
    CallbackComponent,
    ProfileEditComponent,
    SignatureCaptureComponent,
    ProcessPaymentComponent,
  ],
  exports: [
    ProfileComponent,
    HistoryComponent,
    ReviewOrderComponent,
    PaymentConfirmComponent,
    BannerComponent,
    LoginComponent,
    TwoFactorVerificationComponent,
    ErrorMessagesComponent,
    SubscriptionComponent,
    ProfileEditComponent,
    SignatureCaptureComponent,

  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    ImageCropperComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule { }
